<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/dashboard/grupos">Grupos</router-link>
                    <i class="fa fa-chevron-right"></i> Configuración
                  </span>
                </div>
                <!-- <div class="col-6 col-md-6">
                  <button class="btnblanco float-right">
                    Nuevo alumno
                    <i class="fa fa-plus-circle"></i>
                  </button>
                </div>-->
              </div>

              <div class="contenido">
                <div v-if="this.data != null">
                  <div class="row pt-3">
                    <div class="col-sm-12 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-users"></i> Grupo
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Programa Académico:</div>
                            <div class="col-8">
                              {{this.data.programa}} - {{this.data.codigo}}
                              ({{this.data.tipo_ciclo_escolar}})
                            </div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">No. acuerdo:</div>
                            <div class="col-8">{{this.data.no_acuerdo}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Grupo:</div>
                            <div class="col-8">{{this.data.grupo}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Número:</div>
                            <div class="col-8">{{this.data.numero}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="col-sm-6 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-user"></i> Alumno
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Matrícula:</div>
                            <div class="col-8">{{this.matricula}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Nombre:</div>
                            <div
                              class="col-8"
                            >{{this.data.nombre}} {{this.data.apellido_paterno}} {{this.data.apellido_materno}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Email:</div>
                            <div
                              class="col-8"
                            ><a :href="'mailto:'+this.data.user_email">{{this.data.user_email}}</a></div>
                          </div>
                        </div>
                      </div>
                    </div>-->
                  </div>
                </div>

                <div class="row pb-2 pt-2">
                  <div class="col-12">
                    <span class="titulo sub">Edición de Alumnos</span>
                  </div>
                  <!-- <div class="col-6 col-md-6">
                    <button class="btnblanco float-right">
                      Guardar ajustes
                      <i class="fa fa-save"></i>
                    </button>
                  </div>-->
                </div>

                <div class="row pb-5">
                  <div class="col-md-6 pb-3">
                    <div class="lista col-12 bggris rounded pt-3 pb-4 card">
                      <div class="text-center mb-3 pb-2 titulo">Alumnos inscritos</div>
                      <div class="text-center pb-1">
                        <input
                          type="text"
                          class="form-control-sm text-center"
                          placeholder="Búsqueda"
                          v-model="busqueda_inscrito"
                          @keyup="busqueda('inscritos')"
                        />
                      </div>

                      <div class="w-100" v-if="this.inscritos != null">
                        <span v-if="this.inscritos.length == 1">({{this.inscritos.length}} alumno)</span>
                        <span v-if="this.inscritos.length != 1">({{this.inscritos.length}} alumnos)</span>
                      </div>

                      <div class="text-center py-2" v-if="this.inscritos != null">
                        <div class="alumnos">
                          <div
                            class="pt-5"
                            v-if="this.inscritos.length == 0"
                          >No hay alumnos inscritos.</div>

                          <div v-if="this.inscritos.length > 0">
                            <div class="striped pointer">
                              <div
                                v-for="alumno in this.inscritos"
                                v-bind:key="alumno.matricula"
                                v-bind:class="{seleccionado: alumno.seleccionado}"
                                @click="toggleSeleccionAlumno('inscritos',  alumno.matricula)"
                              >
                                <div
                                  class="d-flex py-3 alumno"
                                  v-bind:class="{activo: alumno.filtro}"
                                >
                                  <div class="d-flex justify-content-center align-items-center">
                                    <div v-show="alumno.seleccionado == false">
                                      <i class="fa fa-circle"></i>
                                    </div>
                                    <div v-show="alumno.seleccionado == true">
                                      <i class="fa fa-check-circle"></i>
                                    </div>
                                  </div>
                                  <div class="pr-3">{{alumno.matricula}} - {{alumno.nombre}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="text-center pt-3">
                          <button
                            type="button"
                            class="submit btnblanco"
                            @click="eliminarAlumnos()"
                          >Eliminar seleccionados</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 pb-3">
                    <div class="lista col-12 bggris rounded pt-3 pb-4 card">
                      <div class="text-center mb-3 pb-2 titulo">Alumnos no inscritos</div>

                      <div class="text-center pb-1">
                        <input
                          type="text"
                          class="form-control-sm text-center"
                          placeholder="Búsqueda"
                          v-model="busqueda_no_inscrito"
                          @keyup="busqueda('no_inscritos')"
                        />
                      </div>

                      <div class="w-100" v-if="this.noinscritos != null">
                        <span
                          v-if="this.noinscritos.length == 1"
                        >({{this.noinscritos.length}} alumno)</span>
                        <span
                          v-if="this.noinscritos.length != 1"
                        >({{this.noinscritos.length}} alumnos)</span>
                      </div>

                      <div class="text-center py-2" v-if="this.noinscritos != null">
                        <div class="alumnos">
                          <div class="pt-5" v-if="this.noinscritos.length == 0">No hay más alumnos.</div>

                          <div v-if="this.noinscritos.length > 0">
                            <div class="striped pointer">
                              <div
                                v-for="alumno in this.noinscritos"
                                v-bind:key="alumno.matricula"
                                v-bind:class="{seleccionado: alumno.seleccionado}"
                                @click="toggleSeleccionAlumno('noinscritos',  alumno.matricula)"
                              >
                                <div
                                  class="d-flex py-3 alumno"
                                  v-bind:class="{activo: alumno.filtro}"
                                >
                                  <div class="d-flex justify-content-center align-items-center">
                                    <div v-show="alumno.seleccionado == false">
                                      <i class="fa fa-circle"></i>
                                    </div>
                                    <div v-show="alumno.seleccionado == true">
                                      <i class="fa fa-check-circle"></i>
                                    </div>
                                  </div>
                                  <div class="pr-3">{{alumno.matricula}} - {{alumno.nombre}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="text-center pt-3">
                          <button
                            type="button"
                            class="submit btnblanco"
                            @click="agregarAlumnos()"
                          >Agregar seleccionados</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pb-2 pt-2">
                  <div class="col-12">
                    <span class="titulo sub">Edición de Horarios, Docentes y Ciclo Escolar</span>
                  </div>
                  <!-- <div class="col-6 col-md-6">
                    <button class="btnblanco float-right">
                      Guardar ajustes
                      <i class="fa fa-save"></i>
                    </button>
                  </div>-->
                </div>

                <div class="pb-5">
                  <table
                    class="VueTables__table table table-striped table-bordered table-hover edicioncalificaciones"
                    style="overflow: hidden;"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span class="VueTables__heading">Clave</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Asignatura</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Créditos</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Seriación</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Ciclo Escolar</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Docente</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Horarios</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Editar</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in asignaturas" v-bind:key="item.clave">
                        <td>{{item.clave}}</td>
                        <td>{{item.asignatura}}</td>
                        <td>{{item.creditos}}</td>
                        <td>{{item.seriacion}}</td>
                        <td>{{item.ciclo_escolar_ano}}-{{item.ciclo_escolar}}</td>
                        <td>{{item.nombre_docente}}</td>
                        <td class="horarios">
                          <div class="d-flex botonera">
                            <div class>
                              <div class="non horario" v-html="item.horario"></div>
                            </div>
                          </div>
                        </td>
                        <td class="horarios">
                          <div class="d-flex botonera">
                            <div
                              class="float-right editar btn-sm pointer"
                              @click="edicionAsignatura(item.clave)"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="edicionhorarios"
        v-bind:class="{editando: this.editando}"
        v-if="this.asignaturaedicion != null"
      >
        <div class="dialogo card">
          <div class="col-12">
            <div class="row text-center">
              <div class="col-12 pb-4">
                <h2 class="titulo sub text-left mb-4 w-100 pb-1">
                  <i class="fa fa-pencil-alt"></i>
                  {{this.asignaturaedicion.clave}} - {{this.asignaturaedicion.asignatura}}
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="lunes row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.lunes}"
                      @click="toggleEdicionDia('lunes')"
                    >L</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_lunes"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_lunes"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="martes row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.martes}"
                      @click="toggleEdicionDia('martes')"
                    >M</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_martes"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_martes"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="miercoles row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.miercoles}"
                      @click="toggleEdicionDia('miercoles')"
                    >M</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_miercoles"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_miercoles"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="jueves row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.jueves}"
                      @click="toggleEdicionDia('jueves')"
                    >J</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_jueves"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_jueves"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="viernes row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.viernes}"
                      @click="toggleEdicionDia('viernes')"
                    >V</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_viernes"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_viernes"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="sabado row d-flex justify-content-center align-items-center pb-2">
                  <div class="col-2">
                    <button
                      class="btn btndia"
                      v-bind:class="{activo: edicion.sabado}"
                      @click="toggleEdicionDia('sabado')"
                    >S</button>
                  </div>

                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">de:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_inicio_sabado"
                    ></vue-timepicker>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <div class="pr-1">a:</div>
                    <vue-timepicker
                      hide-disabled-items
                      close-on-complete
                      format="HH:mm"
                      :hour-range="[[6, 23]]"
                      :minute-interval="5"
                      v-model="edicion.horario_fin_sabado"
                    ></vue-timepicker>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-12 titulo">Docente:</div>
                </div>
                <div class="row pb-3">
                  <div class="col-12">
                    <select class="form-control w-100" required v-model="edicion.matricula_docente">
                      <option value hidden>No. de Docente</option>

                      <option
                        :value="item.matricula"
                        v-for="item in this.docentes"
                        v-bind:key="item.matricula"
                      >{{item.nombre}}</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 titulo">Ciclo Escolar:</div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <select class="form-control w-100" required v-model="edicion.ciclo_escolar_ano">
                      <option value hidden>Año</option>

                      <option value="2012">2012</option>
                      <option value="2013">2013</option>
                      <option value="2014">2014</option>
                      <option value="2015">2015</option>
                      <option value="2016">2016</option>
                      <option value="2017">2017</option>
                      <option value="2018">2018</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control w-100" required v-model="edicion.ciclo_escolar">
                      <option value hidden>Ciclo</option>

                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row py-3 pt-4">
              <div class="col-12 offset-0 col-md-4 offset-md-2 text-center pb-2">
                <button class="btn btnblanco float-md-right" @click="guardarDatosAsignatura()">
                  <i class="fa fa-save"></i> Guardar
                </button>
              </div>
              <div class="col-12 col-md-4 text-center pb-2">
                <button
                  class="btn btnblanco float-md-left"
                  @click="cancelarDatosAsignatura()"
                >Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      matricula: "",
      id_grupo: "",
      columns: ["matricula", "nombre", "user_email"],
      datos: null,
      data: null,
      asignaturas: null,
      inscritos: null,
      noinscritos: null,
      busqueda_inscrito: "",
      busqueda_no_inscrito: "",

      asignaturaedicion: null,
      docentes: null,

      edicion: {
        clave: "",
        asignatura: "",
        matricula_docente: "",
        nombre_docente: "",
        horario: "",
        ciclo_escolar: "",
        ciclo_escolar_ano: "",
        lunes: false,
        horario_inicio_lunes: "",
        horario_fin_lunes: "",
        martes: false,
        horario_inicio_martes: "",
        horario_fin_martes: "",
        miercoles: false,
        horario_inicio_miercoles: "",
        horario_fin_miercoles: "",
        jueves: false,
        horario_inicio_jueves: "",
        horario_fin_jueves: "",
        viernes: false,
        horario_inicio_viernes: "",
        horario_fin_viernes: "",
        sabado: false,
        horario_inicio_sabado: "",
        horario_fin_sabado: ""
      },

      editando: false,

      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Clave",
          nombre: "Trimestre",
          user_email: "Calificación"
        },
        editableColumns: ["name"],
        sortable: ["nombre"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "menu-lat": Menu,
    VueTimepicker
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    AOS.init();

    this.numero = this.$route.params.numero;
    this.id_grupo = this.$route.params.id_grupo;

    this.consulta();
    this.consultaAlumnos();
    this.consultaDocentes();
  },
  methods: {
    guardarDatosAsignatura() {
      //if (this.edicion.matricula_docente != "") {
      var vm = this;
      console.log("guardar datos asignatura");
      console.log(this.edicion);
      console.log("fin guardar datos asignatura");

      var horario = "";
      var separador = "";

      if (this.edicion.lunes) {
        horario +=
          "lu - " +
          this.edicion.horario_inicio_lunes +
          " a " +
          this.edicion.horario_fin_lunes +
          " hrs<br>";
      }
      if (this.edicion.martes) {
        horario +=
          "ma - " +
          this.edicion.horario_inicio_martes +
          " a " +
          this.edicion.horario_fin_martes +
          " hrs<br>";
      }
      if (this.edicion.miercoles) {
        horario +=
          "mi - " +
          this.edicion.horario_inicio_miercoles +
          " a " +
          this.edicion.horario_fin_miercoles +
          " hrs<br>";
      }
      if (this.edicion.jueves) {
        horario +=
          "ju - " +
          this.edicion.horario_inicio_jueves +
          " a " +
          this.edicion.horario_fin_jueves +
          " hrs<br>";
      }
      if (this.edicion.viernes) {
        horario +=
          "vi - " +
          this.edicion.horario_inicio_viernes +
          " a " +
          this.edicion.horario_fin_viernes +
          " hrs<br>";
      }
      if (this.edicion.sabado) {
        horario +=
          "sa - " +
          this.edicion.horario_inicio_sabado +
          " a " +
          this.edicion.horario_fin_sabado +
          " hrs<br>";
      }

      horario = horario.substring(0, horario.length - 4);

      this.asignaturaedicion.horario = horario;

      this.asignaturaedicion.matricula_docente = this.edicion.matricula_docente;
      vm.asignaturaedicion.nombre_docente = "";
      this.docentes.forEach(element => {
        if (element.matricula == vm.edicion.matricula_docente) {
          vm.asignaturaedicion.nombre_docente = element.nombre;
        }
      });

      //alert(vm.asignaturaedicion.nombre_docente);

      this.asignaturaedicion.ciclo_escolar_ano = this.edicion.ciclo_escolar_ano;
      this.asignaturaedicion.ciclo_escolar = this.edicion.ciclo_escolar;

      this.editando = false;

      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        numero: this.numero,
        id_grupo: this.id_grupo,
        clave: this.asignaturaedicion.clave,
        codigo: this.data.codigo,
        horario: this.asignaturaedicion.horario,
        matricula_docente: this.asignaturaedicion.matricula_docente,
        ciclo_escolar_ano: this.asignaturaedicion.ciclo_escolar_ano,
        ciclo_escolar: this.asignaturaedicion.ciclo_escolar
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "grupos/guarda-datos-asignatura.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              swal.fire("Bien", res.msg, "success");
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
      // } else {
      //   swal.fire(
      //     "Oops",
      //     "Selecciona un docente antes de continuar...",
      //     "warning"
      //   );
      // }
    },
    cancelarDatosAsignatura() {
      this.editando = false;
    },
    toggleEdicionDia(dia) {
      switch (dia) {
        case "lunes":
          this.edicion.lunes = !this.edicion.lunes;
          break;
        case "martes":
          this.edicion.martes = !this.edicion.martes;
          break;
        case "miercoles":
          this.edicion.miercoles = !this.edicion.miercoles;
          break;
        case "jueves":
          this.edicion.jueves = !this.edicion.jueves;
          break;
        case "viernes":
          this.edicion.viernes = !this.edicion.viernes;
          break;
        case "sabado":
          this.edicion.sabado = !this.edicion.sabado;
          break;
      }
    },
    edicionAsignatura(clave) {
      this.editando = true;

      this.asignaturaedicion = null;
      this.asignaturas.forEach(element => {
        if (element.clave == clave) {
          this.asignaturaedicion = element;
        }
      });

      this.edicion = {
        clave: "",
        asignatura: "",
        matricula_docente: this.asignaturaedicion.matricula_docente,
        nombre_docente: "",
        horario: this.asignaturaedicion.horario,
        ciclo_escolar: this.asignaturaedicion.ciclo_escolar,
        ciclo_escolar_ano: this.asignaturaedicion.ciclo_escolar_ano,
        lunes: false,
        horario_inicio_lunes: "06:00",
        horario_fin_lunes: "06:00",
        martes: false,
        horario_inicio_martes: "06:00",
        horario_fin_martes: "06:00",
        miercoles: false,
        horario_inicio_miercoles: "06:00",
        horario_fin_miercoles: "06:00",
        jueves: false,
        horario_inicio_jueves: "06:00",
        horario_fin_jueves: "06:00",
        viernes: false,
        horario_inicio_viernes: "06:00",
        horario_fin_viernes: "06:00",
        sabado: false,
        horario_inicio_sabado: "06:00",
        horario_fin_sabado: "06:00"
      };

      this.procesaHorarios();

      console.log("asignatura edicion");
      console.log(this.asignaturaedicion);
    },
    procesaHorarios() {
      if (this.edicion.horario != "") {
        var dias = this.edicion.horario.split("<br>");
        console.log("dias");
        console.log(dias);

        var horarios = [];

        dias.forEach(element => {
          var formato = {
            dia: "",
            hora_inicio: "",
            hora_fin: ""
          };

          var temp = element.split(" - ");
          formato.dia = temp[0];

          temp = temp[1].split(" ");
          formato.hora_inicio = temp[0];
          formato.hora_fin = temp[2];

          horarios.push(formato);
        });

        console.log("horarios");
        console.log(horarios);

        horarios.forEach(element => {
          switch (element.dia) {
            case "lu":
              this.edicion.lunes = true;
              this.edicion.horario_inicio_lunes = element.hora_inicio;
              this.edicion.horario_fin_lunes = element.hora_fin;
              break;
            case "ma":
              this.edicion.martes = true;
              this.edicion.horario_inicio_martes = element.hora_inicio;
              this.edicion.horario_fin_martes = element.hora_fin;
              break;
            case "mi":
              this.edicion.miercoles = true;
              this.edicion.horario_inicio_miercoles = element.hora_inicio;
              this.edicion.horario_fin_miercoles = element.hora_fin;
              break;
            case "ju":
              this.edicion.jueves = true;
              this.edicion.horario_inicio_jueves = element.hora_inicio;
              this.edicion.horario_fin_jueves = element.hora_fin;
              break;
            case "vi":
              this.edicion.viernes = true;
              this.edicion.horario_inicio_viernes = element.hora_inicio;
              this.edicion.horario_fin_viernes = element.hora_fin;
              break;
            case "sa":
              this.edicion.sabado = true;
              this.edicion.horario_inicio_sabado = element.hora_inicio;
              this.edicion.horario_fin_sabado = element.hora_fin;
              break;
          }
        });
      }
    },
    busqueda(tipo) {
      //console.log(tipo);
      //console.log(this.noinscritos);

      var bus = null;
      var arre = null;

      if (tipo == "inscritos") {
        bus = this.busqueda_inscrito.toLowerCase();
        arre = this.inscritos;
        //console.log(this.inscritos);
      } else if (tipo == "no_inscritos") {
        bus = this.busqueda_no_inscrito.toLowerCase();
        arre = this.noinscritos;
        //console.log(this.noinscritos);
      }

      //console.log(arre);

      var vm = this;

      arre.forEach(element => {
        //  console.log(element.nombre);
        //  console.log(String(element.nombre).includes(bus));
        //  console.log(bus);
        if (
          String(element.matricula)
            .toLowerCase()
            .includes(bus) ||
          String(element.nombre)
            .toLowerCase()
            .includes(bus)
        ) {
          element.filtro = true;
        } else {
          element.filtro = false;
        }

        //console.log(element.nombre);
        //console.log(element.filtro)

        //console.log(element.filtro);
      });
    },
    toggleSeleccionAlumno(arre, matricula) {
      console.log("click toggle");
      var alumnos = null;

      if (arre == "inscritos") {
        alumnos = this.inscritos;
      } else if (arre == "noinscritos") {
        alumnos = this.noinscritos;
      }

      alumnos.forEach(element => {
        if (element.matricula == matricula) {
          element.seleccionado = !element.seleccionado;
        }
      });
    },
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        numero: this.numero,
        id_grupo: this.id_grupo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "grupos/consulta-grupo-configuracion.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];
              this.asignaturas = res.asignaturas;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consultaAlumnos() {
      console.log("consultando alumnos");
      var vm = this;

      this.busqueda_inscrito = "";
      this.busqueda_no_inscrito = "";

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        id_plantel: this.$store.state.user.id_plantel,
        numero: this.numero,
        id_grupo: this.id_grupo
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      //formData.append("cv", this.file);
      //console.log(this.file);
      console.log(JSON.stringify(userData));

      this.$http
        .post(
          vm.$store.state.baseurl + "grupos/consulta-alumnos.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.registro = 1;
              this.inscritos = res.inscritos;
              this.noinscritos = res.noinscritos;

              console.log(this.inscritos);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consultaDocentes() {
      console.log("consultando docentes");
      var vm = this;

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        id_plantel: this.$store.state.user.id_plantel,
        numero: this.numero,
        id_grupo: this.id_grupo
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      //formData.append("cv", this.file);
      //console.log(this.file);
      console.log(JSON.stringify(userData));

      this.$http
        .post(
          vm.$store.state.baseurl + "grupos/consulta-docentes.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.registro = 1;
              this.docentes = res.docentes;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    agregarAlumnos() {
      var alumnos = [];

      this.noinscritos.forEach(element => {
        if (element.seleccionado) {
          alumnos.push(element.matricula);
        }
      });

      //console.log(alumnos);

      if (alumnos.length > 0) {
        console.log("submit");
        var vm = this;

        const https = require("https");

        vm.$store.state.loading = true;

        var userData = {
          id_plantel: this.$store.state.user.id_plantel,
          id_grupo: this.id_grupo,
          numero: this.numero,
          alumnos: alumnos
        };

        let formData = new FormData();

        formData.append("form_data", JSON.stringify(userData));
        //formData.append("cv", this.file);

        console.log("enviando");
        //console.log(this.file);
        console.log(JSON.stringify(userData));

        this.$http
          .post(vm.$store.state.baseurl + "grupos/alta-alumnos.php", formData, {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          })
          .then(
            response => {
              // get body data
              console.log("envio");
              console.log(response);
              vm.$store.state.loading = false;
              console.log(response.data);
              var res = response.data;

              if (res.status == "ok") {
                swal.fire("Bien", res.msg, "success");
                this.consultaAlumnos();
              } else if (res.status == "notok") {
                swal.fire("Oops", res.msg, "warning");
              }
            },
            error => {
              // error callback
              console.log("error callback");
              console.log(error);
              vm.$store.state.loading = false;
              //console.log(userData);
              swal.fire(
                "Oops",
                "Ha ocurrido un error, por favor intenta de nuevo.",
                "warning"
              );
            }
          );
      } else {
        swal.fire(
          "Oops",
          "Elige alumnos a agregar antes de continuar...",
          "warning"
        );
      }
    },
    eliminarAlumnos() {
      var alumnos = [];

      this.inscritos.forEach(element => {
        if (element.seleccionado) {
          alumnos.push(element.matricula);
        }
      });

      //console.log(alumnos);

      if (alumnos.length > 0) {
        console.log("submit");
        var vm = this;

        const https = require("https");

        vm.$store.state.loading = true;

        var userData = {
          id_plantel: this.$store.state.user.id_plantel,
          id_grupo: this.id_grupo,
          numero: this.numero,
          alumnos: alumnos
        };

        let formData = new FormData();

        formData.append("form_data", JSON.stringify(userData));
        //formData.append("cv", this.file);

        console.log("enviando");
        //console.log(this.file);
        console.log(JSON.stringify(userData));

        this.$http
          .post(vm.$store.state.baseurl + "grupos/baja-alumnos.php", formData, {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          })
          .then(
            response => {
              // get body data
              console.log("envio");
              console.log(response);
              vm.$store.state.loading = false;
              console.log(response.data);
              var res = response.data;

              if (res.status == "ok") {
                swal.fire("Bien", res.msg, "success");
                this.consultaAlumnos();
              } else if (res.status == "notok") {
                swal.fire("Oops", res.msg, "warning");
              }
            },
            error => {
              // error callback
              console.log("error callback");
              console.log(error);
              vm.$store.state.loading = false;
              //console.log(userData);
              swal.fire(
                "Oops",
                "Ha ocurrido un error, por favor intenta de nuevo.",
                "warning"
              );
            }
          );
      } else {
        swal.fire(
          "Oops",
          "Elige alumnos a eliminar antes de continuar...",
          "warning"
        );
      }
    }
  }
};
</script>

